module.exports = __webpack_public_path__ + "img/gh-10247.asm.0f66f07b.jpg";